<div class="row top-field">
  <div class="reports-form-container">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>From Date</mat-label>
      <input matInput [matDatepicker]="frompicker" [(ngModel)]="from_date" placeholder="Choose date" autocomplete="off" readonly
      [max]="maxDate"/>
      <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
      <mat-datepicker #frompicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>To Date</mat-label>
      <input matInput [matDatepicker]="topicker" [(ngModel)]="to_date" placeholder="Choose date" autocomplete="off" readonly [max]="maxDate"/>
      <mat-datepicker-toggle matSuffix [for]="topicker"></mat-datepicker-toggle>
      <mat-datepicker #topicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Test Time</mat-label>
      <input matInput [ngxTimepicker]="picker" [format]="24" placeholder="Select time" [value]="test_time" (click)="picker.open()" readonly>
      <ngx-material-timepicker #picker [defaultTime]="'08:00'" (timeSet)="onTimeSelected($event)">
      </ngx-material-timepicker>
    </mat-form-field>

  </div>
</div>
<div *ngIf="responseLoader">
  <div class="adjust loader-container">
    <div class="loader2"></div>
  </div>
</div>
<div class="row tankmeal" *ngIf="pondsDetails_dropdown && pondsDetails_dropdown.length > 0 && !responseLoader">
  <div class="row batchentry">
    <p>Batch Water Quality</p>
  </div>
  <div class="row eachcard" [ngClass]="{'eachcard' : pondsDetails_dropdown.length > 2 }">
    <div class="row" *ngFor="let pond of pondsDetails_dropdown; let i = index;">
      <div class="row">
        <div class="buttons-div" *ngIf="i == 0 && previewButton" style="padding-bottom: 30px; padding-top: 30px">
          <div class="transactions-button-container">
            <button class="transaction-submit-button" (click)="applyToAllPonds(i);">
              <span class="text"><img src="assets/images/New_Icons/applytoallpond.svg" class="applytoponds">Apply to all ponds</span>
            </button>
          </div>
        </div>
        <div class="col-xs-2 history-top" *ngIf="i >= 1"></div>
      </div>
      <diV class="ponds_card_container">
        <div class="pond_card_header">
          <span class="text">{{pond.pond_name}}</span>
          <div>
              <span  title="Delete Pond" class="deletebtn"
                    (click)="removePond(i)">
                <i class="fa fa-trash-o" (click)="removePond(i)"></i></span>
          </div>
        </div>
        <div class="row row-flex pond_card_body">
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">PH</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.pH"
                           (ngModelChange)="onEditValueChange(i, 'pH', pond.waterQualityLogs.pH)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mol/ltr</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Salinity</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.salinity"
                           (ngModelChange)="onEditValueChange(i, 'salinity', pond.waterQualityLogs.salinity)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppt</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Alkalinity</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.alkalinity"
                           (ngModelChange)="onEditValueChange(i, 'alkalinity', pond.waterQualityLogs.alkalinity)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Turbidity</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.turbidity"
                           (ngModelChange)="onEditValueChange(i, 'turbidity', pond.waterQualityLogs.turbidity)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ntu</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">T.A.N</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.tan"
                           (ngModelChange)="onEditValueChange(i, 'tan', pond.waterQualityLogs.tan)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Temperature</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.temperature"
                           (ngModelChange)="onEditValueChange(i, 'temperature', pond.waterQualityLogs.temperature)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;°C</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">U.Ammonia</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.uam"
                           (ngModelChange)="onEditValueChange(i, 'uam', pond.waterQualityLogs.uam)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Specific Gravity</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.sg"
                           (ngModelChange)="onEditValueChange(i, 'sg', pond.waterQualityLogs.sg)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;cm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Do2</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.do2"
                           (ngModelChange)="onEditValueChange(i, 'do2', pond.waterQualityLogs.do2)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/l</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Conductivity</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.conductivity"
                           (ngModelChange)="onEditValueChange(i, 'conductivity', pond.waterQualityLogs.conductivity)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">TDS</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.tds"
                           (ngModelChange)="onEditValueChange(i, 'tds', pond.waterQualityLogs.tds)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Nitrite</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.nitrite"
                           (ngModelChange)="onEditValueChange(i, 'nitrite', pond.waterQualityLogs.nitrite)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">ORP</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.orp"
                           (ngModelChange)="onEditValueChange(i, 'orp', pond.waterQualityLogs.orp)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mV</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Magnesium</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.magnesium"
                           (ngModelChange)="onEditValueChange(i, 'magnesium', pond.waterQualityLogs.magnesium)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Calcium</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.calcium"
                           (ngModelChange)="onEditValueChange(i, 'calcium', pond.waterQualityLogs.calcium)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Plankton</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.plankton"
                           (ngModelChange)="onEditValueChange(i, 'plankton', pond.waterQualityLogs.plankton)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;No/L</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">BOD</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.bod"
                           (ngModelChange)="onEditValueChange(i, 'bod', pond.waterQualityLogs.bod)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/L</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Co2</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.co2"
                           (ngModelChange)="onEditValueChange(i, 'co2', pond.waterQualityLogs.co2)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Phosphorous</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.phosphorus"
                           (ngModelChange)="onEditValueChange(i, 'phosphorus', pond.waterQualityLogs.phosphorus)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;mg/L</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">H2s-Gas</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.h2sGas"
                           (ngModelChange)="onEditValueChange(i, 'h2sGas', pond.waterQualityLogs.h2sGas)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Iron</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.iron"
                           (ngModelChange)="onEditValueChange(i, 'iron', pond.waterQualityLogs.iron)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Potassium</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.potassium"
                           (ngModelChange)="onEditValueChange(i, 'potassium', pond.waterQualityLogs.potassium)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">D.A</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.da"
                           (ngModelChange)="onEditValueChange(i, 'da', pond.waterQualityLogs.da)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;%</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <div class="parameter_container">
              <span class="parameter_name">Sodium</span>
              <span><input type="text" class="input-field numberInput" (keypress)="validateNumber($event)"
                           [(ngModel)]="pond.waterQualityLogs.sodium"
                           (ngModelChange)="onEditValueChange(i, 'sodium', pond.waterQualityLogs.sodium)"
                           [ngClass]="{'disable-input-field': !showInput}">&nbsp;&nbsp;ppm</span>
            </div>
          </div>
        </div>
      </diV>
    </div>
  </div>
  <div class="row" *ngIf="editButton && submitButton">
    <div style="text-align: center; margin: 2% 0%;">
      <button class="transactionsubmit" id="btnSubmit" *ngIf="editButton"
              [ngClass]="isCommitDisabled ? 'disbledCls' : ''" (click)="editBatchWaterQualityReadings()">
        <span class="icon"><img src="../../../../../../assets/images/New_Icons/edit.svg"></span><span>Edit</span>
      </button>
      <button class="transactionreset" id="btnReset" *ngIf="submitButton"
              [ngClass]="isCommitDisabled ? 'disbledCls' : ''" (click)="addBatchWaterQualityReadings()">
        <span class="icon"><img src="../../../../../../assets/images/New_Icons/commit.svg" width="30"></span><span>Commit</span>
      </button>
    </div>
  </div>
  <div class="row" *ngIf="previewButton">
    <div style="text-align: center; padding: 30px">
      <button class="preview-button" (click)="priviewBatchWaterQualityReadings()">
        <span><img src="../../../../../../assets/images/New_Icons/preview.svg" width="20"></span><span>Preview</span>
      </button>
    </div>
  </div>
</div>
<div *ngIf="pondsDetails_dropdown && pondsDetails_dropdown.length == 0 && !responseLoader" class="noDataFoundMessage">
  Ponds are not available for this section
</div>
